/* eslint-disable jsx-a11y/alt-text */
import "./discourse.css";
import { ColoredDivider } from "../ColoredDivider/ColoredDivider";
import Button from "react-bootstrap/Button";
import { PGSDK } from "../../pgsdk";
import { Modal } from "bootstrap";
//import {isGenius} from HomePage
import {isGenius} from "../HomePage/HomePage";


export default function DiscourseForum({ forumEnabled, getTopic,scrollSize,publisherID,idAsNumber}) {

  const inlineStyle = {
    position: scrollSize ? 'sticky' : '',
    bottom:scrollSize ? '25px' : '',
    opacity:scrollSize ?  1 : '',
    transition: scrollSize? "all 0.5s ease-out":''
  };

  const navigateTo=()=>{

    var currentDate = new Date();
    var dayNumber = currentDate.getDate();
    let discourceNumber = parseInt(dayNumber) + 21;
    if (discourceNumber === 49) {
      discourceNumber = 55
    }

    console.log('discourceNumber 0',discourceNumber);
   // discourceNumber = 15;

     window.open(`https://smartfriends.discourse.group/t/${discourceNumber}`, '_blank');

//     const a = document.createElement('a');
// a.href = `https://smartfriends.discourse.group/t/${discourceNumber}`;
// a.target = '_blank';
// a.rel = 'noopener noreferrer'; // Security measure
// a.click();
    
  // const clickedURL = `https://smartfriends.discourse.group/t/${discourceNumber}`;// event.target.getAttribute("href");
    //setHereURL(clickedURL)
    // if(clickedURL){
    //   setDataFromChild(true);
    // }


  // <iframe src = "https://smartfriends.discourse.group/t/50" width="800" height="600"></iframe>

   
//    }
// fetch('https://cors-anywhere.herokuapp.com/https://smartfriends.discourse.group/t/50}')
//   .then(response => response.text())
//   .then(data => console.log(data))
//   .catch(error => console.error(error));
    
    
  }


  if (forumEnabled === true) {
    
    return (
      
      <div className="comments">
        <div className="comments-header">
          {/* <h1>Commetns</h1> */}
        </div>
        {getTopic?.post_stream?.posts.map((item, index) => {
          return index !== 0 ? (
            <div key={item.id}>
              <div className="comment-container">
                <div className="avatar">
                  <img src={item.avatar_template.replace("{size}", "50")} />
                </div>
                <div className="username">
                  <p>{item?.display_username}</p>
                </div>
                <div className="cooked">
                  <p dangerouslySetInnerHTML={{ __html: item.cooked }}></p>
                </div>
              </div>
              <ColoredDivider />
            </div>
          ): null;
        })}
       
        <div onClick={()=>{navigateTo()}} style={inlineStyle} className="button">
          <Button>
         
              Write a comment
           
          </Button>
         
        </div>
      </div>
    );
  }
}
